
  <div class="card-container">
    <div class="card card-small" (click)="navigateTo('code')">
      <span>{{'{ Code }'}}</span>
    </div>
    <div class="card card-small" (click)="navigateTo('demo')">
      <span>{{'< Demo >'}}</span>
    </div>
  </div>